module.exports = __webpack_public_path__ + "img/32_16.a2a80019.png";